import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrowright",
  "use": "arrowright-usage",
  "viewBox": "0 0 8 14",
  "content": "<symbol viewBox=\"0 0 8 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrowright\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.94995 6.99999L-4.57595e-05 2.04999L1.41395 0.635986L7.77795 6.99999L1.41395 13.364L-4.56414e-05 11.95L4.94995 6.99999Z\" fill=\"#DC3819\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrowright.svg
// module id = 427
// module chunks = 0